import { RuleEditorDropdownMode, RuleEditorDropdownModeCategory } from '../NodeEditorDrawer/types';

export enum CaretIndexType {
  EXPRESSION = 'expression',
  MLA = 'mla',
}

export const startingCaretPosition = '-1!caret';
export const mlaCTACaretPositionString = 'cta-0!mlaAddOptionalFilter';

export const ruleEditorModeToCategoryMap = {
  // GROUP
  [RuleEditorDropdownMode.GROUP_START]: RuleEditorDropdownModeCategory.GROUP,
  [RuleEditorDropdownMode.GROUP_START_PENDING]: RuleEditorDropdownModeCategory.GROUP,
  [RuleEditorDropdownMode.GROUP_END]: RuleEditorDropdownModeCategory.GROUP,

  // DATAROUTE
  [RuleEditorDropdownMode.DATAROUTE_SOURCE]: RuleEditorDropdownModeCategory.DATAROUTE,
  [RuleEditorDropdownMode.DATAROUTE_ATTRIBUTE]: RuleEditorDropdownModeCategory.DATAROUTE,
};
